import { parse } from 'date-fns';

export const formatDateDMY = (date: Date, delimiter = '/', printMonth = false) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  if (printMonth) {
    const printedMonth = date.toLocaleDateString('default', { month: 'short' });
    return `${day < 10 ? `0${day}` : day}${delimiter}${printedMonth}${delimiter}${year}`;
  } else {
    return `${day < 10 ? `0${day}` : day}${delimiter}${month < 10 ? `0${month}` : month}${delimiter}${year}`;
  }
};

export const formatDateTime = (date: Date) => {
  const hour = date.getHours();
  const minute = date.getMinutes();

  return `${formatDateDMY(date)} ${hour < 10 ? `0${hour}` : hour}:${minute < 10 ? `0${minute}` : minute} ${
    hour < 12 ? 'am' : 'pm'
  }`;
};

export const formatDateTime12Hrs = (date: Date) => {
  let hour = date.getHours();
  const minute = date.getMinutes();
  const half = hour < 12 ? 'am' : 'pm';
  if (hour > 12) hour = hour - 12;

  return `${formatDateDMY(date)} ${hour}:${minute < 10 ? `0${minute}` : minute}${half}`;
};

export const formatDateTime12hrsPrintMonth = (date: Date) => {
  let hour = date.getHours();
  const minute = date.getMinutes();
  const half = hour < 12 ? 'am' : 'pm';
  if (hour > 12) hour = hour - 12;

  return `${formatDateDMY(date, ' ', true)} ${hour}:${minute < 10 ? `0${minute}` : minute}${half}`;
};

export const formatDateYMD = (date: Date, delimiter = '-') => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return `${year}${delimiter}${month < 10 ? `0${month}` : month}${delimiter}${day < 10 ? `0${day}` : day}`;
};

const getFullDayMonth = (value: string) => {
  if (value.length < 2) return '0' + value;
  return value;
};

export const parseTimeZoneDate = (date: Date, timeZone = 'Australia/Melbourne') => {
  if (Object.prototype.toString.call(date) === '[object Date]') {
    const d = new Date(date);
    const opt = { timeZone: timeZone };
    const year = d.toLocaleDateString('en-us', { ...opt, year: 'numeric' });
    const monthFull = getFullDayMonth(d.toLocaleDateString('en-us', { ...opt, month: 'numeric' }).slice(-2));
    const dayFull = getFullDayMonth(d.toLocaleDateString('en-us', { ...opt, day: 'numeric' }).slice(-2));
    return {
      day: d.toLocaleDateString('en-us', { ...opt, day: 'numeric' }),
      dayFull,
      monthLong: d.toLocaleDateString('en-us', {
        month: 'long',
      }),
      monthShort: d.toLocaleDateString('en-us', { ...opt, month: 'short' }),
      month: d.toLocaleDateString('en-us', { ...opt, month: 'numeric' }),
      monthFull,
      year,
      yearShort: d.toLocaleDateString('en-us', { ...opt, year: 'numeric' }).substring(2, 4),
      isoDate: `${year}-${monthFull}-${dayFull}`,
    };
  }
  return;
};

export const getFriendlyDate = (date: string): string => {
  if (date) {
    try {
      const melbDate = parseTimeZoneDate(parse(date, 'yyyy-MM-dd', new Date()));
      if (!melbDate) return '';
      return `${melbDate.day} ${melbDate.monthShort} ${melbDate.year}`;
    } catch (e) {
      console.error('Error parsing delivery date', date);
    }
  }
  return '';
};

export const getNumericDate = (date: string, includeFullYear: boolean = true): string => {
  if (date) {
    try {
      const melbDate = parseTimeZoneDate(parse(date, 'yyyy-MM-dd', new Date()));
      if (!melbDate) return '';
      return `${melbDate.day}/${melbDate.monthFull}/${includeFullYear ? melbDate.year : melbDate.yearShort}`;
    } catch (e) {
      console.error('Error parsing delivery date', date);
    }
  }
  return '';
};

export const getDateDifferenceInTime = (dateA: Date, dateB: Date) => {
  return dateB.getTime() - dateA.getTime();
};

export const getDateDifferenceInDays = (dateA: Date, dateB: Date) => {
  return getDateDifferenceInTime(dateA, dateB) / (1000 * 3600 * 24);
};
